import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Field, formValueSelector, reduxForm, reset, change } from 'redux-form';
import { getMasterData, getPatientsList, showPatientsSubMenus, UploadClientListFile } from './actions/PatientActions';
import Alert from 'react-s-alert';
import history from '../../history';
import { renderAutoCompleteMultipleSelection, renderTextField, renderCheckBox } from '../../components/reduxFields';
import PaginatorCustom from '../../components/paginationCustom';
import SortingCustom from '../../components/SortingCustom';
import GlobalVariables, { resetFiltersAndSorting, base64Encode } from '../../actions/utilAction';
import { CommonButton } from '../../components/buttons';
import PatientInternalNotesModal from './PatientInternalNotes_Modal';
//import UploadDocumentScreen from './UploadDocumentScreen';

class ManagePatients extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      users: [],
      includedData: [],
      masterTags: null,                  
      ShowPatientOfAllLocations : false,
      ShowInactiveClientsOnly : false,
      clicked: false,
      patientIdShowHide: null,
      openInternalNotesModal: false,
      PatientId: null,
      isExcludeTag: false,
      allClientTag: [],
      displaySelectedWithTags: false,
    };

    this.filter = {
      sort_Column: 'id',
      sort_Order: 'desc',
      searchText: '',      
    };

    this.openDialog = this.openDialog.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    this.handleSearchUserName = this.handleSearchUserName.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleResetButton = this.handleResetButton.bind(this);    
    this.openDialogForRenderingProvider = this.openDialogForRenderingProvider.bind(this);    
    this.handleUploadFile = this.handleUploadFile.bind(this);
  }

  componentWillMount() {
    this.props.showPatientsSubMenus(false);
    this.loadData();
    this.props.getMasterData('MASTERTAGSFORPATIENT');    
  }

  loadData(page_number) {
    let searchObj = {
      contain_filters: {
        Tags: this.state.masterTags ? this.state.masterTags : null,
        LocationIDs: this.state.ShowPatientOfAllLocations ? '0' : this.props.currentLocationId ? this.props.currentLocationId : '0',
        searchkey: this.filter.searchText ? this.filter.searchText : undefined,      
        ShowInactiveClientsOnly: this.state.ShowInactiveClientsOnly ? '1' : '0',  
        ViewTeamClientsOnly: this.props.viewTeamClientsOnlyPermission,
        isExcludeTag: this.state.isExcludeTag ? true : false,
        displaySelectedClientsWithTags: this.state.displaySelectedWithTags ? true : false
      },
      sort_fields: this.filter.sort_Column || 'id',
      sort_order: this.filter.sort_Order || 'desc',
      pageNumber: page_number || 1,
      pageSize: GlobalVariables.pageSize,
    };
    this.props.getPatientsList(searchObj);
  }

  openDialogForRenderingProvider(e,patientId) {
    e.preventDefault();
    this.setState({ clicked: this.state.clicked === false ? true : false, patientIdShowHide: patientId });
  }

  componentWillUnmount() {
    Alert.closeAll();
  }

  openDialog = () => {
    this.setState({ open: true });
    history.push('/user');
  }
  closeDialog = () => {
    this.setState({ open: false, openInternalNotesModal: false });
  };
  handleSearchUserName(event) {
    // if (event.Username != undefined) {
    //   this.searchText = event.Username;
    //   let searchObj = {
    //     sort_fields: this.filter.sort_Column ? this.filter.sort_Column : '-id',
    //     contain_filters: { firstname: this.searchText },
    //     page_number: 1,
    //     includes: 'include=userroles',
    //   };
    //   this.props.getUserNameBySearchText(searchObj);
    // } else {
    //   this.searchText = '';
    //   this.loadData();
    // }
  }

  handleOpenInternalNotes = (event, obj) => {
    // console.log('event, staffId.........', obj)
    this.setState({ openInternalNotesModal: true, PatientId: obj.patientId });
  };

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_Order = col_order;
      this.loadData();
    }
  }

  handleSearchChange(event) {
    if (event.target.value.length > 0) {
      this.filter.searchText = event.target.value;
      this.loadData();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadData();
    }
  };
  handleResetButton() {
    Alert.closeAll();
    this.props.dispatch(reset('ManagePatientsForm'));
    resetFiltersAndSorting(this.filter, 'id', true);    
    this.setState({
      open: false,
      users: [],
      includedData: [],
      masterTags: null,  
      ShowPatientOfAllLocations : false,
      ShowInactiveClientsOnly : false, 
      allClientTag: [],
      isExcludeTag: false,
      displaySelectedWithTags: false               
    }, () => {
      this.props.dispatch(change('ManagePatientsForm', 'ExcludeTag', false));
      this.props.dispatch(change('ManagePatientsForm', 'DisplaySelectedWithTags', false));      
      // this.props.dispatch(change('ManagePatientsForm', 'Name', null));
      // this.props.dispatch(change('ManagePatientsForm', 'tags', null));      
      this.loadData();
    });
  };

  handleNewRequest = (input, values, noContent, label, data) => {
    input.onChange(values);
    let searchTerm = '';
    let searchValues = [];
    let allClientTag = []
    if (data && data.length) {
      data.forEach((selectedData, i) => {
        searchValues.push(selectedData.value);
        allClientTag.push(selectedData.id)
      });
      searchTerm = searchValues.join(',');
      this.setState({ masterTags: searchTerm, allClientTag: allClientTag }, () => {
        if(data.length < 2) {
          this.setState({ displaySelectedWithTags: false, }, () => {            
            this.props.dispatch(change('ManagePatientsForm', 'DisplaySelectedWithTags', false));        
            this.loadData();
          });          
        }
        else {
          this.loadData();
        }        
      });
    } else {
      this.setState({ masterTags: null, allClientTag: [], isExcludeTag: false, displaySelectedWithTags: false }, () => {
        this.props.dispatch(change('ManagePatientsForm', 'ExcludeTag', false));
        this.props.dispatch(change('ManagePatientsForm', 'DisplaySelectedWithTags', false));        
        this.loadData();
      });
    }
  };
  

  handleAdvanceFilterCheck = (input, name) => {
    this.setState({ [name]: input.target.checked },
      () => {
        this.loadData();
      });
  }

  handleViewClick=(obj, e) => {
    let patientId = base64Encode(`${obj.patientId}`);
    history.push('/client/profile/' + `${patientId}`);
  };

  handleEditClick=(obj, e) => {
    let patientId = base64Encode(`${obj.patientId}`);
    history.push('/client/' + `${patientId}`);
  };

  isExcludeTagHandler = (e) => {

    if (e.target.checked) {
      this.setState({
        isExcludeTag: true,
        displaySelectedWithTags: false,
      }, () =>  {
       this.props.dispatch(change('ManagePatientsForm', 'DisplaySelectedWithTags', false));      
       this.loadData()
      });
    }
    else {
      this.setState({
        isExcludeTag: false,
        displaySelectedWithTags: false,
      }, () =>  {
        this.props.dispatch(change('ManagePatientsForm', 'DisplaySelectedWithTags', false));      
        this.loadData()
       });
    }
    
  }

  isDisplaySelectedClientsWithTagsHandler = (e) => {
    if (e.target.checked) {
      this.setState({
        displaySelectedWithTags: true,
        isExcludeTag: false,
      },  () =>  {
        this.props.dispatch(change('ManagePatientsForm', 'ExcludeTag', false));      
        this.loadData()
       });
    }
    else {
      this.setState({
        isExcludeTag: false,
        displaySelectedWithTags: false,
      },  () =>  {
        this.props.dispatch(change('ManagePatientsForm', 'ExcludeTag', false));      
        this.loadData()
       });
    }
  }

  handleUploadFile() {    
    let self = this;
    let uploadSheetObj = {};
    let fileArr = this.refs.child.handleClick();
    let base64Array = [];
    let base64String = '';
    let objInside = {};
  
    fileArr.forEach((obj) => {
      let fileExtension = obj.name.split('.').pop().toLowerCase();
      let promise = this.getBase64(obj);
      promise.then(function (result) {
        let base64pre = `${result}`;
        let newBase64pre = base64pre.replace(/^data:([a-z]+\/[a-z0-9-+.]+(;[a-z-]+=[a-z0-9-]+)?)?(;base64)?,/, '');
        let finalBase64pre = `"${newBase64pre}": "${fileExtension}"`;
        base64String = `${finalBase64pre}`;
        base64Array.push(base64String);

        objInside = base64Array.reduce(function (acc, cur, i) {
          acc[i] = cur;
          return acc;
        }, {});

        uploadSheetObj = {          
          'base64': objInside,        
        };
        console.log('uploadSheetObj...........',uploadSheetObj)
        if (base64Array.length === fileArr.length) {
          self.props.UploadClientListFile(uploadSheetObj);
        }
      });
    });
  }
  
  getBase64(file, onLoadCallback) {
    return new Promise(function(resolve, reject) {
      let reader = new FileReader();
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  calculateFileSizehandler = (files) => {
    let totalFileSize = 0;
    let fileSizeInKB = 0;
    // @desc - define const max upload file size 5MB
    let totalFileSizeInMB = 0;
    const fileSize20MB = 20.00;
    files.map((obj, i) => {
      totalFileSize = totalFileSize + obj.size;
      totalFileSizeInMB = ((totalFileSize / 1024) / 1024).toFixed(2);
      fileSizeInKB = Math.round(obj.size / 1024); // converted bytes(incoming file size) to KB.
      // 1024kb = 1MB
      let fileSizeInMB = Math.round((obj.size / 1024) / 1024);
      let fileSizeInMBFixTo2Decimal = fileSizeInMB.toFixed(2);
      return fileSizeInKB >= 1024 ? `${fileSizeInMBFixTo2Decimal}MB` : `${fileSizeInKB}KB`;
    });

    if (parseFloat(fileSizeInKB) === 0.00 || parseFloat(totalFileSizeInMB) > parseFloat(fileSize20MB)) {
      this.setState({ isValidFileSize: false });
    } else {
      this.setState({ isValidFileSize: true });
    }
  };
  renderData() {
    if (this.props.patientsList && this.props.patientsList.data && this.props.patientsList.data.length > 0) {
      return this.props.patientsList.data.map((obj, index) => {        
        return (
          <tr key={index}>
            <td>{`${obj.firstName} ${obj.lastName}`}</td>
            {/* <td>{obj.username || '-'}</td> */}
            <td>{obj.email || '-'}</td>
            <td>{obj.emergencyContactName || '-'}</td>          
            <td>{obj.emergencyContactPhone || '-'}</td>          
            <td>{obj.locationName}</td>   
            <td>
              <div className="renderingprovider" onClick={(e) => this.openDialogForRenderingProvider(e,obj.patientId)}>                               
                <i className="fa fa-info-circle infoIcon" aria-hidden="true" title="Click here to view rendering providers"></i>                
                
                <div className={this.state.clicked  && this.state.patientIdShowHide === obj.patientId ? 'renderingproviderbox renderingprovidershow' : 'renderingproviderbox renderingproviderhide'}>
                  <div className="renderingproviderheader">
                    <h3>Rendering Providers</h3>
                    <div className="renderingprovidericons">
                      <ul>
                        <li><a title="close" href=""><i className="fa fa-times"></i></a></li>
                      </ul>
                    </div>
                  </div>
                  <div className="renderingprovidercontent">                                       
                    <div className="renderingprovidersoapdate">
                      <ul>
                          {obj.renderingProviders.map((data, index) => {
                          return (
                            <li key={data.renderingProviderId} >                          
                              <span>{data.therapyName}</span> - <span>{data.renderingProviderName}</span>                          
                            </li>
                          );
                        })
                        }
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </td>       
            <td className={obj.isActive === true ? 'greenfont' : 'redfont'}>{obj.isActive ? 'Active' : 'Inactive'}</td>            
            <td>
              {this.props.viewProfileSmryPermission ?
                <button onClick={this.handleViewClick.bind(this, obj)} type="button" title="View Profile" className="tbactionbtn yellowfont"><i className="fa fa-eye" aria-hidden="true"></i></button>                            
                : null
              }            
              {this.props.updatePermission ?
                <button onClick={(e) => this.handleOpenInternalNotes(e, obj)} type="button" title="Client Internal Notes" className="tbactionbtn bluefont"><i className="fa fa-sticky-note-o" aria-hidden="true"></i></button>
                : null
              }
              {/* <button onClick={this.handleEditClick.bind(this, obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button> */}
            </td>
          </tr>
        );
      });
    } else {
      return (<tr>
        <td colSpan='8' className="text-center no-record">{this.props.loading ? 'Loading, Please wait...' : 'No record found.'}</td>
      </tr>);
    }
  };

  render() {
    const { handleSubmit } = this.props;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.bordered,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
    });
    return (
      <div>
        {this.state.openInternalNotesModal ? <PatientInternalNotesModal patientId={this.state.PatientId} closeDialog={this.closeDialog} /> : null}
        <h2 className="page_title">Manage Clients</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <div className="modalwindow userlist">
              <div className="row">                
                <div className="col-sm-12">
                  <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchUserName)}>
                    <div className="row end-flex">
                      <div className="col-sm-4 field-mr">
                        <Field
                          name="ShowPatientOfAllLocations"
                          label="Include All Locations"
                          component={renderCheckBox}
                          onChange={(e) => this.handleAdvanceFilterCheck(e, 'ShowPatientOfAllLocations')}
                        />
                      </div>
                      <div className="col-sm-4 field-mr">
                        <Field
                          name="ShowInactiveClientsOnly"
                          label="Show Inactive Clients Only"
                          component={renderCheckBox}
                          onChange={(e) => this.handleAdvanceFilterCheck(e, 'ShowInactiveClientsOnly')}
                        />
                      </div>
                      
                      <div className="col-sm-4 mtm-27">
                        <Field
                          name="Name"
                          floatingLabelText="Search By Name"
                          maxLength="100"
                          fullWidth={true}
                          onChange={this.handleSearchChange}
                          component={renderTextField}
                        />
                      </div>
                      </div>
                      <div className="row end-flex">
                        <div className="col-sm-4 field-mr">
                          <Field
                            name="tags" 
                            label="Tags"
                            handleNewRequest={this.handleNewRequest}
                            options={this.props.masterTags}
                            component={renderAutoCompleteMultipleSelection} />
                        </div>
                        <div className="col-sm-2 field-mr">
                        {this.state.allClientTag.length > 0  && <Field
                            name="ExcludeTag"
                            label="Exclude Tag"
                            component={renderCheckBox}
                            onChange={(e) => this.isExcludeTagHandler(e)}
                          />}
                        </div>
                        <div className="col-sm-4 field-mr">
                        {this.state.allClientTag.length > 1  && <Field
                            name="DisplaySelectedWithTags"
                            label="Display clients who have all of the selected tags."
                            component={renderCheckBox}
                            onChange={(e) => this.isDisplaySelectedClientsWithTagsHandler(e)}
                          />}
                        </div>
                        <div className="reset-btn col-sm-2 btn_rt">
                          <CommonButton className="grey_btn" name ='reset' onTouchTap={this.handleResetButton} label = 'Reset' />
                        </div>
                    </div>
                    {/* <div className="row end-flex">
                        <div className="col-sm-4 mt-10">
                          <UploadDocumentScreen ref="child" calculateFileSizehandler={this.calculateFileSizehandler.bind(this)} />                           
                      </div>             
                      <div className="col-sm-4">                          
                          <CommonButton className="grey_btn" name='add_client' label="Upload File" primary={true} onTouchTap={this.handleUploadFile}  />                            
                      </div>     
                        <div className="col-sm-4">                          
                          <CommonButton className="grey_btn" name='add_client' label="Download Sample" />                            
                      </div>                     
                    </div> */}
                  </form>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12 mt-20">
                <div className="table-responsive">
                  <table className={tableClass}>
                    <thead>
                      <tr>
                        <th width="20%"><SortingCustom setSortColumn={this.setSortColumn} columnName='firstName' displayName='Name' /></th>
                        {/* <th width="13%">User Name</th>                      */}
                        <th width="15%">Email</th>
                        <th width="18%">Emergency Contact</th>
                        <th width="10%">Phone</th>
                        <th width="17%">Location</th>
                        <th width="10%">Rend. Provider</th>
                        <th width="8%">Status</th>
                        <th width="5%">{this.props.viewProfileSmryPermission ? 'Action' : ''}</th>             
                      </tr>
                    </thead>
                    <tbody>
                      {this.renderData()}
                    </tbody>
                  </table>
                </div>
                {this.props.patientsList && this.props.patientsList.meta ?
                  <PaginatorCustom data={this.props.patientsList.meta} handlePageChange={(page_number) => this.loadData(page_number)} />
                  : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const selectorUserTagForm = formValueSelector('ManagePatientsForm');

function mapStateToProps(state) {

    // Start For Role Permission
    let userScreenPermission = [];
    let userActionPermission = [];
    if (state.login.userPermission) {
      let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'CLIENT');
      userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
      
      let userScreenPermissionEdit = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'CLIENT_PROFILE' && obj.moduleId === userModulePermission[0].moduleId);
      userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermissionEdit[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
    }

    let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let viewProfileSmryPermission = hasDefaultAccess ? true : userScreenPermission ? userScreenPermission.filter((obj) => obj.screenKey === 'CLIENT_PROFILE')[0].permission : false;
  let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'CLIENT_PROFILE_UPDATE')[0].permission : false;
  let viewTeamClientsOnlyPermission = hasDefaultAccess ? false : userScreenPermission ? userScreenPermission.filter((obj) => obj.screenKey === 'VIEW_TEAM_CLIENTS_ONLY')[0].permission : false;  
  // End For Role Permission

  let masterTagsforPatient = [];
  if (state.user.master_data) {    
    masterTagsforPatient = state.user.master_data.masterTagsforPatient || [];
  };
  return {    
    patientsList: state.patient.patientsList,    
    loading: state.user.loading,
    masterTags: masterTagsforPatient,        
    currentLocationId: state.login.currentLocationId,   
    viewProfileSmryPermission: viewProfileSmryPermission,
    viewTeamClientsOnlyPermission: viewTeamClientsOnlyPermission,             
    updatePermission: updatePermission,
    selectorUserTag: selectorUserTagForm(state, 'tags'),
  };
}

ManagePatients = reduxForm({
  form: 'ManagePatientsForm',
  enableReinitialize: true,
})(ManagePatients);

export default connect(mapStateToProps, { getPatientsList, getMasterData, showPatientsSubMenus, UploadClientListFile })(ManagePatients);



// WEBPACK FOOTER //
// ./src/modules/patients/PatientList.js